// extracted by mini-css-extract-plugin
export default {"linksContainer":"Contact_linksContainer__3PLbg","link":"Contact_link__0DfEh","text":"Contact_text__GDqvH"};